import React, { useMemo } from 'react'
import styles from './index.less'
import { ItemType } from './interface.d'
import ProductTwoLine from './components/two-line'
import ProductOneLine from './components/one-line'
import { isOdd, formatBannerList } from './utils'
import { IProps } from '@/typings/utils'
// 国内的数据配置
interface CNProps {
  CName: string
  uid: string
  componentIndex: number
  pageId: string
  needScene?: boolean
  productList?: ItemType[]
  componentStyle?: number
  outputBusiness: any
}
const SliderBanner = (props: IProps<CNProps>) => {
  const { componentStyle } = props.propsConfig

  const productList = useMemo(() => {
    return formatBannerList(props.propsConfig.productList)
  }, [props.propsConfig.productList])

  const groups = useMemo(() => {
    const resultGroup = []
    if (productList.length) {
      for (let i = 0; i < productList.length; i++) {
        const item = Object.assign({}, productList[i], { index: i })
        if (isOdd(i)) {
          resultGroup[Math.floor(i / 2)].push(item)
        } else {
          resultGroup.push([item])
        }
      }
    }
    return resultGroup
  }, [productList])

  const showTwoLine = componentStyle === 2 && groups.length
  const showOneLine = componentStyle === 1 && productList.length
  return (
    <div className={styles.wrapper}>
      {showTwoLine ? <ProductTwoLine {...props.propsConfig} groups={groups} /> : null}
      {showOneLine ? <ProductOneLine {...props.propsConfig} productList={productList} /> : null}
    </div>
  )
}

const PoizonSliderBanner = React.memo(SliderBanner)

PoizonSliderBanner.config = {
  name: 'poizon-slider-banner',
  noSsr: true,
}

export default PoizonSliderBanner
